<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template >
  <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">

    <v-nav-menu
      :navMenuItems = "navMenuItems"
      parent        = ".layout--main" />

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
    <div id="content-overlay" />

    <template>
      <the-navbar-vertical
        :navbarColor="navbarColor"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />
    </template>
    <!-- /Navbar -->

      <div class="content-wrapper">

        <div class="router-view">
          <div class="router-content">

            <transition :name="routerTransition" mode="out-in">

              <div :key="$route.meta.pageTitle" v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-2">
                <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <h3 class="mb-1 inline-block font-medium">{{ routeTitle }}</h3>
                  <span v-if="$route.meta.isGlobal"></span>
                  <span v-else>
                    <span v-if="$store.state.dash.isMulti" class="text-3xl inline-block mx-1"> • </span><span class="w-full text-dark" v-if="$store.state.dash.isMulti">{{ $store.state.dash.viewData.business.businessName }}</span>
                  </span>                  
                </div>
                <!-- BREADCRUMB -->
                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />
                <vs-divider/>
              </div>

            </transition>

            <div class="content-area__content">

              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                  <router-view :key="'abc' + String($store.state.dash.currentMultiLocationI) + 'abc' /*This is to forceupdate surveflow component on multi change*/" @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
              </transition>

            </div>

  

            <vs-popup class="holamundo" title="Add showcase tag" :active.sync="showCreateTagModal" @close="$store.commit('dash/TOGGLE_SHOW_CREATE_TAG')">           
        <p class="mb-4">Enter a text tag for this item.</p>        
        <vs-input  size="large" class="w-full" v-validate="'max:20'" name="Tag" ref="tagBox" placeholder="E.g. 'Website Homepage'" v-model="createTagText"/>        
        <p class="my-4 text-sm text-light">Tags may not contain any special characters.</p>        
        <span class="text-danger block mt-4">{{ errors.first('Tag') }}</span>
         <div class="con-vs-alert mt-1 con-vs-alert-success">
          <h4 class="titlex vs-alert--title">Showcase Tag</h4>
          <div class="vs-alert text-lg">
          <p>This will add this item to showcase and label it with a tag you provide below.</p>
          <p class="mt-4">Tagging allows you to create seperate showcase widgets that only contains specific items (based on a specific tag).</p>
          <p class="mt-4">A tag is like a 'label'. For instance, you can tag some items of showcase as "Website front page", and create a widget for your site front page that only contains those items.</p>
        </div>
        </div>
        <p class="text-danger my-4 font-medium" v-if="createTagErrorText">{{createTagErrorText}}</p>
        <div class="overflow-auto mt-4">
          <vs-button class="float-right ml-1 px-32" @click="confirmCreateTag" :disabled="createTagText.trim() === '' || createTagText.trim().length > 20">Ok</vs-button>
          <vs-button type="border" class="float-right" @click="$store.commit('dash/TOGGLE_SHOW_CREATE_TAG')">Cancel</vs-button>
        </div>        
      </vs-popup>


          </div>
        </div>
      </div>

    </div>

    <help-widget />
  </div>
</template>


<script>

//<the-footer />

import BackToTop           from 'vue-backtotop'
import navMenuItems        from '@/layouts/components/vertical-nav-menu/navMenuItems.js'
import TheNavbarVertical   from '@/layouts/components/navbar/TheNavbarVertical.vue'
//import TheFooter           from '@/layouts/components/TheFooter.vue'
import themeConfig         from '@/../themeConfig.js'
import VNavMenu            from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
import HelpWidget          from '@/layouts/components/HelpWidget.vue'

export default {
  components: {
    BackToTop,
    //TheFooter,
    TheNavbarVertical,
    VNavMenu,
    HelpWidget
  },
  data () {
    return {
      createTagErrorText: false,
      disableCustomizer : themeConfig.disableCustomizer,
      disableThemeTour  : themeConfig.disableThemeTour,
      dynamicWatchers   : {},
      footerType        : themeConfig.footerType  || 'static',
      hideScrollToTop   : themeConfig.hideScrollToTop,
      isNavbarDark      : false,
      navbarColor       : themeConfig.navbarColor || '#fff',
      navbarType        : themeConfig.navbarType  || 'floating',
      navMenuItems,
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle,
    }
  },
  watch: {
    '$route' () {
      this.routeTitle = this.$route.meta.pageTitle
    },
    isThemeDark (val) {
      const color = this.navbarColor === '#fff' && val ? '#10163a' : '#fff'
      this.updateNavbarColor(color)
    },
    '$store.state.mainLayoutType' (val) {
      this.setNavMenuVisibility(val)
      this.disableThemeTour = true
    }
  },
  computed: {
    createTagText: {
      set(v) {
        this.$store.commit('dash/CHANGE_CREATE_TAG_TEXT', v.trim().replace(/[^a-zA-Z0-9 ]/g, ""))
      },
      get() {
        return this.$store.state.dash.viewState.createTagText
      }
    },
    showCreateTagModal: {
      set(s) {
        this.$store.commit('dash/TOGGLE_SHOW_CREATE_TAG')
      },
      get() {
        return this.$store.state.dash.viewState.showCreateTagModal
      }
    },
    bodyOverlay () { return this.$store.state.bodyOverlay },
    contentAreaClass () {
      if (this.mainLayoutType === 'vertical') {
        if      (this.verticalNavMenuWidth === 'default') return 'content-area-reduced'
        else if (this.verticalNavMenuWidth === 'reduced') return 'content-area-lg'
        else return 'content-area-full'
      } else return 'content-area-full'
    },
    footerClasses () {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static'
      }
    },
    isAppPage () {
      return this.$route.meta.no_scroll
    },
    isThemeDark ()     { return this.$store.state.theme === 'dark' },
    layoutTypeClass () { return `main-${this.mainLayoutType}`      },
    mainLayoutType ()  { return this.$store.state.mainLayoutType   },
    navbarClasses ()   {
      return {
        'navbar-hidden'   : this.navbarType === 'hidden',
        'navbar-sticky'   : this.navbarType === 'sticky',
        'navbar-static'   : this.navbarType === 'static',
        'navbar-floating' : this.navbarType === 'floating'
      }
    },
    verticalNavMenuWidth () { return this.$store.state.verticalNavMenuWidth },
    windowWidth ()          { return this.$store.state.windowWidth }
  },
  methods: {
    confirmCreateTag () {

      this.createTagErrorText = false
      //check that it's unique

      let hasMatch = false
      this.$store.state.dash.viewData.currentTags.forEach((tag) => {
        if (tag.trim().toLowerCase() === this.createTagText.trim().toLowerCase()) hasMatch = true
      })

      if (hasMatch) {
        this.createTagErrorText = `You already have a tag called "${this.createTagText}". Showcase this item by clicking on that tag, and not on "Add tag".`
        return
      }

      this.$store.state.dash.viewState.createTagCall(true, this.createTagText)
      this.$store.commit('dash/TOGGLE_SHOW_CREATE_TAG')
      
    },
    changeRouteTitle (title) {
      this.routeTitle = title
    },
    updateNavbar (val) {
      if (val === 'static') this.updateNavbarColor(this.isThemeDark ? '#10163a' : '#fff')
      this.navbarType = val
    },
    updateNavbarColor (val) {
      this.navbarColor = val
      if (val === '#fff') this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    updateFooter (val) {
      this.footerType = val
    },
    updateRouterTransition (val) {
      this.routerTransition = val
    },
    setNavMenuVisibility (layoutType) {
      if ((layoutType === 'horizontal' && this.windowWidth >= 1350) || (layoutType === 'vertical' && this.windowWidth < 1350)) {
        //noconsoleconsole.log('-------CHANGING NAV MENU ------ FALSE')
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      } else {
        //noconsoleconsole.log('-------CHANGING NAV MENU ------ TRUE')
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    },
    toggleHideScrollToTop (val) {
      this.hideScrollToTop = val
    }
  },
  created () {
    const color = this.navbarColor === '#fff' && this.isThemeDark ? '#10163a' : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)

    // Dynamic Watchers for tour
    // Reason: Once tour is disabled it is not required to enable it.
    // So, watcher is required for just disabling it.
    this.dynamicWatchers.windowWidth = this.$watch('$store.state.windowWidth', (val) => {
      if (val < 1200) {
        this.disableThemeTour = true
        this.dynamicWatchers.windowWidth()
      }
    })

    this.dynamicWatchers.verticalNavMenuWidth = this.$watch('$store.state.verticalNavMenuWidth', () => {
      this.disableThemeTour = true
      this.dynamicWatchers.verticalNavMenuWidth()
    })

    this.dynamicWatchers.rtl = this.$watch('$vs.rtl', () => {
      this.disableThemeTour = true
      this.dynamicWatchers.rtl()
    })
  },
  beforeDestroy () {
    Object.keys(this.dynamicWatchers).map(i => {
      this.dynamicWatchers[i]()
      delete this.dynamicWatchers[i]
    })
  }
}

</script>
